import "./chooseMedia.css";
import {
  React,
  useEffect,
  useCallback,
  TabView,
  TabPanel,
  useGetMediaMutation,
  FileUploader,
  VideoThumbnail,
  Radio,
  Empty,
  memo,
  toast,
  useState,
  Box,
  LoadingSpinner,
  GetCookie,
  axios,
  BASEURL,
  captureeventbaseanalytics,
} from "../../../Libraries/Post/AddNewPost/Child/AddPostMiddleForm/ChooseMedia/index";
import { CONTENT_BASEURL, MAX_UPLOAD_FILE_SIZE } from "../../../Utils/Constants/constants";

const fileTypes = ["JPG", "PNG", "mp4"];

const ChooseMedia = (props) => {
  const [getMedia, { isLoading: loadingwhilemediagetting }] =
    useGetMediaMutation();
  const [data, setdata] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalprogress, settotalprogress] = useState(0);
  const [isloading, setisloading] = useState(false);

  const onUploadProgress = (event) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    settotalprogress(percentCompleted);
    if (percentCompleted === 100) {
      setTimeout(() => {
        settotalprogress(0);
      }, 400);
    }
  };

  const handleChange = async (file) => {
    if (file) {
      if (file.size >= MAX_UPLOAD_FILE_SIZE) {
        toast.info("Max file upload size is 900Mb");
      } else {
        setisloading(true);
        const mediadata = new FormData();
        mediadata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        mediadata.append("security_token", await GetCookie("es_token"));
        mediadata.append("upload_type", "File");
        mediadata.append("myFile", file);
        try {
          setisloading(true);
          const returned = await axios.post(
            CONTENT_BASEURL + "boostboard-content/addMedia.php",
            mediadata,
            { onUploadProgress }
          );
          if (
            returned.data.status === "true" &&
            returned.data.connection === "true" &&
            returned.data.message === "File uploaded successfully"
          ) {
            setisloading(false);
            captureeventbaseanalytics(
              "Media",
              "postMedia.php upload_type:File RESPONSE",
              returned.data.message
            );
            toast.success(returned.data.message);
            getAllMediaFunc();
            setActiveIndex(0);
          } else {
            setisloading(false);
            toast.error(returned.data.message);
            captureeventbaseanalytics(
              "Media",
              "postMedia.php upload_type:File RESPONSE",
              returned.data.message
            );
          }
        } catch (error) {
          console.log(error);
          setisloading(false);
          toast.error(error.status);
          captureeventbaseanalytics(
            "Media",
            "postMedia.php upload_type:File RESPONSE",
            error.status
          );
        }
      }
    } else {
      toast.error("No File Selected");
    }
  };

  const handleSelectedFile = useCallback(
    (e, file, type, media_id) => {
      props?.setfinalfile({
        value: e.target.value,
        link: file,
        type: type,
        ser_media_id: media_id,
      });
    },
    [props]
  );

  const getAllMediaFunc = useCallback(async () => {
    try {
      const Mediadata = new FormData();
      Mediadata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      Mediadata.append("security_token", await GetCookie("es_token"));
      const res = await getMedia(Mediadata).unwrap();
      if (
        res.message === "Media available" &&
        res.status === "true" &&
        res.connection === "true"
      ) {
        // console.log("wahaj mag 4", res.data)
        setdata(res.data);
      } else {
        toast.info(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  }, [getMedia]);

  useEffect(() => {
    // console.log("wahaj mag 2 = ", props)
    getAllMediaFunc();
  }, [getMedia, getAllMediaFunc]);

  return (
    <>
      {isloading || loadingwhilemediagetting ? (
        <LoadingSpinner totalprogress={totalprogress} />
      ) : null}
      <div className="tabview-demo">
        <TabView
          style={{ borderRadius: "10px" }}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="Choose From Media Library">
            <Box>
              <div className="grid mb-3">
                {data.length > 0 ? (
                  data?.map((image, index) => (
                    <div className="md:col-3 lg:col-3 g-1" key={index}>
                      <div className="surface-0 shadow-2 carddesign outerdesign">
                        <div className="flex justify-content-end p-2">
                          <div
                            className="flex align-items-center justify-content-center border-round"
                            style={{ width: "1.5rem", height: "1.5rem" }}
                          >
                            <Radio
                              checked={
                                props?.finalfile?.value ===
                                image.txt_media_full_name
                              }
                              name="radio-buttons"
                              value={image.txt_media_full_name}
                              onChange={(e) =>
                                handleSelectedFile(
                                  e,
                                  image.txt_media_streaming_link,
                                  image.txt_media_file_type,
                                  image.ser_media_id
                                )
                              }
                              inputProps={{ "aria-label": "A" }}
                            />
                          </div>
                        </div>
                        {image.txt_media_file_type === "Image" ? (
                          <img
                            src={
                              image.txt_media_streaming_link !== null
                                ? image.txt_media_streaming_link
                                : VideoThumbnail
                            }
                            alt="layouts"
                            height="150px"
                            width="100%"
                            className="layoutimages"
                          />
                        ) : image.txt_media_file_type === "Video" ? (
                          <img
                            src={
                              image.base64_media_thumbnail !== null
                                ? image.base64_media_thumbnail
                                : VideoThumbnail
                            }
                            alt="layouts"
                            height="150px"
                            width="100%"
                            className="layoutimages"
                          />
                        ) : (
                          <img
                            src={VideoThumbnail}
                            alt="layouts"
                            height="150px"
                            width="100%"
                            className="layoutimages"
                          />
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="d-flex justify-content-center flex-column align-items-center w-100">
                    <Empty />
                  </div>
                )}
              </div>
            </Box>
          </TabPanel>
          {/* <TabPanel header="Choose Widgets">

          </TabPanel> */}
          <TabPanel header="Choose From Your Computer">
            <div className="choosemediainaddpost">
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
              />
            </div>
          </TabPanel>
        </TabView>
      </div>
    </>
  );
};

export default memo(ChooseMedia);
